import { getViewData } from './modules/view-data';

/**
 * Resolve a promise
 *
 * @param data
 * @returns {Promise}
 */
export function pollResolver(data = {}) {
    let interval;

    function checkCondition(resolve) {
        const resolver = () => {
            resolve(
                data.return
                    ? data.return()
                    : undefined
            );
        };

        if (data.when && data.when()) {
            clearInterval(interval);
            resolver();
        }

        return false;
    }

    return new Promise((resolve) => {
        if (!checkCondition(resolve)) {
            interval = setInterval(() => {
                checkCondition(resolve);
            }, 100);
        }
    });
}

/**
 * Async inject a script into the DOM
 *
 * @param {Object} data
 * @returns {Promise}
 */
export function loadScript(data = {}) {
    const scriptId = `script-${data.name}`;
    // Don't add the script if it already exists
    if (document.getElementById(scriptId)) {
        // If the script condition hasn't yet
        // been met we'll poll
        if (data.when && !data.when()) {
            return pollResolver(data);
        }

        // If a return function has been provided use that,
        // otherwise return `undefined`
        const resolveData = (data.return)
            ? data.return()
            : undefined;

        return Promise.resolve(resolveData);
    }

    // Add the script to the DOM
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = data.src;
    script.id = scriptId;
    document.body.appendChild(script);

    return pollResolver(data);
}

 /*
 * Remove non alphanumeric and space characters from vehicle registration
 * @param reg
 * @returns {*|String}
 */
export function formatVehicleRegistration(reg = '') {
    try {
        return (reg || '').replace(/[^0-9a-z ]/gi, '');
    } catch (e) {
    }
}

export async function loadRecaptchaV3() {
    return await loadScript({
        name: 'google-recaptcha-v3',
        src: `https://www.google.com/recaptcha/api.js?badge=bottomleft&render=${getViewData('google_recaptcha_v3_site_key')}`,
        when() {
            return window.grecaptcha;
        },
        return () {
            return window.grecaptcha;
        }
    });
}

/**
 * @param {String} action
 * @returns {Promise<String>}
 */
export async function executeRecaptchaV3(action) {
    const grecaptcha = await loadRecaptchaV3();

    await new Promise((resolve) => grecaptcha.ready(resolve));

    return grecaptcha.execute(getViewData('google_recaptcha_v3_site_key'), { action });
}
